import * as yup from 'yup';
import type { IValidationField } from '../types';

export default function representative({ label = '' }: IValidationField) {
  return yup.object().shape({
    representativeCode: yup.string().label(label).required().default(''),
    representativeName: yup.string().nullable().default(''),
    representativeEmail: yup.string().nullable().default(''),
  });
}
